import { useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import lightlogoPic from "../../assets/lightlogo2.png";
import darklogoPic from "../../assets/akka-colorfull1.svg";
import ConnectWalletButton from "./ConnectWalletButton";
import Logo from "./Logo/Logo";
import ChangeThemeButton from "./ChangeThemeButton";

function Header() {
  const [toggle, setToggle] = useState(true);
  const toggleMenu = () => {
    setToggle(!toggle);
    setDropdown(false);
  };
  const [dropdown, setDropdown] = useState(false);
  const themeMode = useSelector(({ theme }) => theme.value);

  return (
    <nav
      className={`${
        themeMode === "light" ? "bg-[#F5F5FA]" : "bg-[#22223d]"
      } shadow-lg pt-[6px] md:px-[50px] px-[0px] md:min-h-[7vh]`}
    >
      <div className='container mx-auto relative z-10'>
        <div className='flex justify-between pl-[24px] pr-[24px] md:px-[0px]'>
          <div className='flex space-x-7'>
            <div>
              <Link to='/' className='flex items-center py-4'>
                {/* Main Menu Logo */}
                <Logo
                  logoPic={themeMode === "light" ? darklogoPic : lightlogoPic}
                />
              </Link>
            </div>
            {/* Primary Navbar items */}
            {/* <Menu /> */}
          </div>
          {/* Secondary Navbar items */}
          <div
            className={`flex items-center space-x-3 `}
          >
            {/* Connect wallet button */}
            <ConnectWalletButton />
            {/* change theme button */}
            <ChangeThemeButton />
          </div>
          {/* Mobile menu button */}
          {/* <button
              onClick={toggleMenu}
              className="outline-none mobile-menu-button"
            >
              <svg
                className=" w-6 h-6 text-gray-500 hover:text-green-500 "
                x-show="!showMenu"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path d="M4 6h16M4 12h16M4 18h16"></path>
              </svg>
            </button> */}
        </div>
      </div>
      {/* mobile menu */}
      {/* <div className={`${toggle ? "hidden" : ""} mobile-menu`}>
        <ul className="">
          <li className="active">
            <a
              href="index.html"
              className="block text-sm px-2 py-4 text-white bg-green-500 font-semibold"
            >
              Home
            </a>
          </li>
          <li>
            <a
              href="#services"
              className="block text-sm px-2 py-4 hover:bg-green-500 transition duration-300"
            >
              Services
            </a>
          </li>
          <li>
            <a
              href="#about"
              className="block text-sm px-2 py-4 hover:bg-green-500 transition duration-300"
            >
              About
            </a>
          </li>
          <li>
            <a
              href="#contact"
              className="block text-sm px-2 py-4 hover:bg-green-500 transition duration-300"
            >
              Contact Us
            </a>
          </li>
          <li></li>
        </ul>
      </div> */}
    </nav>
  );
}

export default Header;
